import appStoreBadge from '@/assets/download-on-the-app-store.svg';
import playStoreBadge from '@/assets/google-play-badge.svg';
import { APP_STORE_URL, PLAY_STORE_URL } from '@/config/appStore';

interface AppStoreBadgesProps {
  height?: string;
  className?: string;
  playStoreScaleClass?: string;
}

export function AppStoreBadges({
  height = 'h-12',
  className = '',
  playStoreScaleClass = 'scale-[1.45]',
}: AppStoreBadgesProps) {
  return (
    <div className={`flex flex-wrap items-center justify-center gap-4 ${className}`}>
      <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
        <img src={appStoreBadge} alt="Download on the App Store" className={`${height} object-contain`} />
      </a>
      <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center">
        <img src={playStoreBadge} alt="Get it on Google Play" className={`${height} object-contain ${playStoreScaleClass}`} />
      </a>
    </div>
  );
}
